import { navigateTo } from '#imports'

import { useBouyguesStore } from '@backmarket/nuxt-layer-checkout/stores/bouyguesStore'
import { hasSelectedOnlineMobilePlan } from '@backmarket/nuxt-layer-checkout/utils/mobilePlan/hasSelectedMobilePlan'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

import { CHECKOUT } from '../../routes-names'

export function useRedirectBouyguesMobilePlan() {
  const bouyguesStore = useBouyguesStore()

  const redirectBouyguesMobilePlan = async (
    items: ApiSpecs['/bm/cart']['GET']['response']['cartItems'],
  ) => {
    const hasBouyguesAuthToken = !isEmpty(bouyguesStore.accessToken)
    const hasBouyguesPhonelineInfo = !isEmpty(
      bouyguesStore.phonelineSetupInformation,
    )
    const hasCompleteBouyguesFlow =
      hasBouyguesAuthToken && hasBouyguesPhonelineInfo

    const hasBouyguesMobilePlan = hasSelectedOnlineMobilePlan(items)

    if (hasBouyguesMobilePlan && !hasCompleteBouyguesFlow) {
      await navigateTo({
        name: !hasBouyguesAuthToken
          ? CHECKOUT.SERVICES.BOUYGUES.SIGN_UP
          : CHECKOUT.SERVICES.BOUYGUES.PHONELINE_SETUP,
      })
    }
  }

  return { redirectBouyguesMobilePlan }
}
